import * as React from 'react';
import { UitkRemovablePill } from 'uitk-react-pill';
import { RouteStore } from 'bernie-core';
import { stringify } from 'query-string';
import { amenityLegacyEquals } from 'utils/amenity-mapper';

export interface PlaybackFilterPillProps {
  pill: PillProps;
  routeStore?: RouteStore;
  analytics?: any;
  disabled: boolean;
}

export interface PillProps {
  query?: string;
  name: string;
  label: string;
  value: any;
  generated: boolean; // Only set by BEX API
}

export interface PlaybackFilterPillState {
  hide: boolean;
}

export class PlaybackFilterPill extends React.Component<PlaybackFilterPillProps, PlaybackFilterPillState> {
  constructor(props) {
    super(props);

    this.state = { hide: false };

    this.dismissPillAndUpdateSearch = this.dismissPillAndUpdateSearch.bind(this);
    this.sendTracking = this.sendTracking.bind(this);
  }

  private dismissPillAndUpdateSearch() {
    const { routeStore, pill } = this.props;

    this.sendTracking();

    if (pill.query && pill.query.length > 0) {
      routeStore.updateSearch(pill.query);
    } else if (pill.generated) {
      // BEX API does not return pills urls. Instead we can calculate which param to remove from
      // the information we already have
      const currentParams = { ...routeStore.queryParams };
      const dismissValue = pill.value;
      const isPriceFilter = pill.name === 'price';
      const isMultiplePriceFiltersSelected = dismissValue && dismissValue.toString().indexOf(',') >= 0;
      if (isPriceFilter && isMultiplePriceFiltersSelected) {
        currentParams[pill.name] = '';
        routeStore.updateSearch(stringify(currentParams));
      } else {
        const preFilteredParams = currentParams[pill.name];
        let filteredParams;
        if (preFilteredParams instanceof Array) {
          filteredParams = preFilteredParams.filter(pillValue => !amenityLegacyEquals(pillValue, dismissValue));
        } else {
          filteredParams = amenityLegacyEquals(preFilteredParams, dismissValue) ? '' : preFilteredParams;
        }
        currentParams[pill.name] = filteredParams;
        routeStore.updateSearch(stringify(currentParams));
      }
    }

    this.setState({ hide: true });

    if (document && document.dispatchEvent && typeof document.dispatchEvent === 'function' && CustomEvent) {
      document.dispatchEvent(
        new CustomEvent('mesoSlotFilterUpdate', { detail: { type: 'slotFilter', editType: 'remove', filterData: pill } })
      );
    }
  }

  private sendTracking() {
    const { pill, analytics } = this.props;
    const { name, value } = pill;
    const suffix = `playback.${name}.${value}`;
    analytics.clickTracker(`.${suffix}`, suffix)();
  }

  public render() {
    const pill = this.props.pill;

    if (this.state.hide || !pill || !pill.label) {
      return null;
    }

    const { name, label, value } = pill;
    const valueId = typeof value === 'string' ? value.replace(/,/g, '-') : value;
    const key = `playback-filter-pill-${name}-${valueId}`;

    return (
      <UitkRemovablePill id={key} key={key} onClick={this.dismissPillAndUpdateSearch} disabled={this.props.disabled}>
        <span className="playback-pill-grid-item-label">{label}</span>
      </UitkRemovablePill>
    );
  }
}
